export default __webpack_public_path__ + "1b80b02d926a96488aa071ddf215fa08.svg";